export const cardSizes = ['xs', 'sm', 'md', 'lg'] as const;
export type CardSize = (typeof cardSizes)[number];

export const CardPaddingMap: Record<CardSize, number> = {
  lg: 7,
  md: 5,
  sm: 3,
  xs: 2,
};
